if (window.geo) {
	const POSITION_INTERVAL = 1000 * 60 * 5; // 5 minut
	const sendPosition = () => {
		window.geo.getCurrentPositionSilently().then(result => {
			if (result?.location && "latitude" in result.location && "longitude" in result.location && "accuracy" in result.location) {
				Mapy.userLocation = {
					source: "geolocation",
					position: {
						lat: result.location.latitude,
						lon: result.location.longitude,
						accuracy: result.location.accuracy,
					},
				};
				Mapy.getComponent("logger").log("geolocation-periodic");
			}
		}, () => {});
	};

	sendPosition();
	setInterval(sendPosition, POSITION_INTERVAL);
}
